/* ============================================================
   TARZ engagement features — wishlist + recently viewed.
   Both persist in localStorage; no apps or accounts required.
   ============================================================ */
(function () {
  const WISHLIST_KEY = 'tarz_wishlist';
  const RECENT_KEY = 'tarz_recent';
  const RECENT_MAX = 12;

  const read = key => {
    try { return JSON.parse(localStorage.getItem(key)) || []; } catch (e) { return []; }
  };
  const write = (key, value) => {
    try { localStorage.setItem(key, JSON.stringify(value)); } catch (e) {}
  };
  const money = cents => 'Rs.' + (cents / 100).toLocaleString('en-PK');
  const toast = msg => { if (window.tarzToast) window.tarzToast(msg); };
  const sized = (url, w) => {
    if (!url) return '';
    return url + (url.includes('?') ? '&' : '?') + 'width=' + w;
  };

  /* Current product (PDP only — parsed from the #ProductJson script tag) */
  function currentProduct() {
    const el = document.getElementById('ProductJson');
    if (!el) return null;
    try {
      const p = JSON.parse(el.textContent);
      return {
        id: p.id,
        handle: p.handle,
        title: p.title,
        image: p.featured_image || (p.images && p.images[0]) || '',
        price: p.price,
        compare: p.compare_at_price || 0,
        url: '/products/' + p.handle
      };
    } catch (e) { return null; }
  }

  /* ─── Wishlist ──────────────────────────────────────────── */
  const wishlist = {
    all: () => read(WISHLIST_KEY),
    has: id => read(WISHLIST_KEY).some(i => String(i.id) === String(id)),
    toggle(item) {
      let items = read(WISHLIST_KEY);
      const exists = items.some(i => String(i.id) === String(item.id));
      items = exists ? items.filter(i => String(i.id) !== String(item.id)) : [item, ...items];
      write(WISHLIST_KEY, items);
      return !exists;
    },
    remove(id) {
      write(WISHLIST_KEY, read(WISHLIST_KEY).filter(i => String(i.id) !== String(id)));
    }
  };

  function itemFromButton(btn) {
    const d = btn.dataset;
    if (d.handle) {
      return {
        id: d.productId, handle: d.handle, title: d.title,
        image: d.image, price: +d.price, compare: +(d.compare || 0), url: d.url
      };
    }
    return currentProduct();
  }

  function paintHearts() {
    document.querySelectorAll('.wishlist-btn, .gallery-wishlist').forEach(btn => {
      const item = itemFromButton(btn);
      const on = item && wishlist.has(item.id);
      btn.classList.toggle('active', !!on);
      const svg = btn.querySelector('svg');
      if (svg) {
        svg.setAttribute('fill', on ? '#e05c6a' : 'none');
        svg.style.stroke = on ? '#e05c6a' : '';
      }
    });
  }

  function paintBadges() {
    const count = wishlist.all().length;
    document.querySelectorAll('[data-wishlist-count]').forEach(badge => {
      badge.textContent = count;
      badge.style.display = count > 0 ? 'flex' : 'none';
    });
  }

  /* ─── Wishlist drawer ───────────────────────────────────── */
  const drawer = document.getElementById('wishlistDrawer');
  const overlay = document.getElementById('wishlistOverlay');

  function renderDrawer() {
    if (!drawer) return;
    const list = drawer.querySelector('#wishlistItems');
    const empty = drawer.querySelector('#wishlistEmpty');
    const items = wishlist.all();
    empty.hidden = items.length > 0;
    list.innerHTML = items.map(i => `
      <div class="wishlist-item" data-id="${i.id}">
        <a href="${i.url}" class="wishlist-item-img"><img src="${sized(i.image, 160)}" alt="" loading="lazy"></a>
        <div class="wishlist-item-info">
          <a href="${i.url}" class="wishlist-item-name">${i.title}</a>
          <span class="wishlist-item-price">${money(i.price)}${i.compare > i.price ? ' <s>' + money(i.compare) + '</s>' : ''}</span>
          <a href="${i.url}" class="wishlist-item-view">View &amp; choose size →</a>
        </div>
        <button type="button" class="wishlist-item-remove" data-wishlist-remove="${i.id}" aria-label="Remove ${i.title.replace(/"/g, '&quot;')} from wishlist">
          <svg width="14" height="14" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
        </button>
      </div>`).join('');
  }

  function openDrawer() {
    if (!drawer) return;
    renderDrawer();
    drawer.hidden = false;
    overlay.hidden = false;
    void drawer.offsetHeight; // reflow so the slide-in transition runs
    drawer.classList.add('open');
    overlay.classList.add('open');
    document.body.style.overflow = 'hidden';
  }

  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('open');
    overlay.classList.remove('open');
    document.body.style.overflow = '';
    setTimeout(() => { drawer.hidden = true; overlay.hidden = true; }, 260);
  }

  /* ─── Recently viewed ───────────────────────────────────── */
  function recordVisit() {
    const p = currentProduct();
    if (!p) return;
    let items = read(RECENT_KEY).filter(i => String(i.id) !== String(p.id));
    items.unshift(p);
    write(RECENT_KEY, items.slice(0, RECENT_MAX));
  }

  function renderRecentlyViewed() {
    document.querySelectorAll('[data-recently-viewed]').forEach(grid => {
      const current = currentProduct();
      const items = read(RECENT_KEY)
        .filter(i => !current || String(i.id) !== String(current.id))
        .slice(0, +grid.dataset.recentlyViewed || 8);
      const section = grid.closest('.recently-viewed-section');
      if (!items.length) { if (section) section.hidden = true; return; }
      if (section) section.hidden = false;
      grid.innerHTML = items.map(i => `
        <article class="product-card" role="listitem">
          <a href="${i.url}" class="product-image"><img src="${sized(i.image, 480)}" alt="${i.title.replace(/"/g, '&quot;')}" loading="lazy"></a>
          <div class="product-info">
            <div class="product-price-row">
              <div class="product-price-col">
                <span class="product-price">${money(i.price)}</span>
                ${i.compare > i.price ? '<span class="product-price-original">' + money(i.compare) + '</span>' : ''}
              </div>
              <a href="${i.url}" class="product-cart-btn" aria-label="View ${i.title.replace(/"/g, '&quot;')}">
                <svg width="15" height="15" fill="none" stroke="currentColor" stroke-width="1.8" viewBox="0 0 24 24"><line x1="7" y1="17" x2="17" y2="7"/><polyline points="8 7 17 7 17 16"/></svg>
              </a>
            </div>
            <span class="product-brand-name">${i.title}</span>
          </div>
        </article>`).join('');
    });
  }

  /* ─── Wiring ────────────────────────────────────────────── */
  document.addEventListener('click', e => {
    const heart = e.target.closest('.wishlist-btn, .gallery-wishlist');
    if (heart) {
      e.preventDefault();
      e.stopPropagation();
      const item = itemFromButton(heart);
      if (!item) return;
      const added = wishlist.toggle(item);
      paintHearts();
      paintBadges();
      toast(added ? 'Added to wishlist ♥' : 'Removed from wishlist');
      return;
    }

    if (e.target.closest('.wishlist-header-btn') || e.target.closest('a[href="#wishlist"]')) {
      e.preventDefault();
      openDrawer();
      return;
    }

    const removeBtn = e.target.closest('[data-wishlist-remove]');
    if (removeBtn) {
      wishlist.remove(removeBtn.dataset.wishlistRemove);
      renderDrawer();
      paintHearts();
      paintBadges();
    }
  }, true);

  document.getElementById('wishlistClose')?.addEventListener('click', closeDrawer);
  overlay?.addEventListener('click', closeDrawer);
  document.addEventListener('keydown', e => {
    if (e.key === 'Escape' && drawer && !drawer.hidden) closeDrawer();
  });

  recordVisit();
  renderRecentlyViewed();
  paintHearts();
  paintBadges();
})();
